// The display kit's `file` element (docs/features/session-files.md, docs/features/display-kit.md): a file on the Mac,
// shown by path — {"type": "file", "path": "/Users/…/chart.png", "height": 220, "title": "optional"} — QuickLook's
// picture of it, fetched from the Mac when the pane draws, and a tap opens its preview (windows/macfile). The agent
// never puts the bytes in its reply; a relative path is the session's folder's.
//
// The host gives the drawing's state `fileSource` = {ctx, where: {session, directory}, changed} (agent-pane, the
// display window); without one (a pane with no Mac behind it) the element is the file's name and path, still a tap.
import { esc, icon, addSymbols } from '../../core/kit.js'
import { layoutParts } from './display.js'
import { thumbOf, size, kindOf } from '../session/session-files.js'

addSymbols({ photo: 'image', 'doc.richtext': 'file-text', film: 'film', waveform: 'audio-lines', 'doc.text': 'file-text', doc: 'file' })
const SYMBOL = { image: 'photo', pdf: 'doc.richtext', video: 'film', audio: 'waveform', text: 'doc.text', file: 'doc' }

export function fileHTML(x, st) {
  const path = String(x.path ?? x.file ?? '').trim()
  if (!path) return ''
  const name = String(x.title || path.split('/').pop())
  const src = st?.fileSource
  const t = src?.ctx ? thumbOf(src.ctx, src.where, path, () => src.changed?.()) : null
  const height = Math.max(60, Math.min(900, +x.height || 220))
  const kind = t?.kind || kindOf(path)
  const sub = [t?.total != null ? size(t.total) : '', kind, t?.state === 'failed' ? t.why : ''].filter(Boolean).join(' · ')
  const picture = t?.src
    ? `<img class="dk-fileimg" src="${t.src}" alt="${esc(name)}" style="height:${height}px">`
    : `<div class="dk-fileph" style="height:${Math.min(height, 120)}px"><img class="sym" src="${icon(SYMBOL[kind] || 'doc', 'rgb(var(--c-ink-rgb) / 0.6)')}">${t?.state === 'asking' ? '<span>Asking the Mac…</span>' : ''}</div>`
  return `<button class="dk-file" data-act="${esc('mdfile:' + path)}" title="${esc(path)}">${picture}<div class="dk-rt"><div class="dk-rtitle">${esc(name)}</div><div class="dk-rdetail">${esc(sub || path)}</div></div></button>`
}

layoutParts.file = fileHTML
